export const getRequiredDepthForRomans = (driveControl: string) => {
  if (driveControl === '') return [];
  const driveControlStripped = driveControl.replace('Drive Control: ', '');
  const romanBlindDepths = [
    {
      driveControl: 'Chain',
      depth: '45mm',
    },
    {
      driveControl: 'Chainless',
      depth: '45mm',
    },
  ];

  return romanBlindDepths.filter(
    options => options.driveControl === driveControlStripped,
  );
};
